'use client';

import Image from 'next/image';
import React, { FC } from 'react';

import PartFeatureCaseItem from '@/components/part-feature-case-item';
import { IContentImage } from '@/contentful/utils/contentImage';
import { IFeaturedItem } from '@/contentful/utils/featuredItem';

import styles from './part-description.module.scss';

interface IPartDescriptionProps {
  data: {
    beforeImage: IContentImage | null;
    beforeText: string;
    afterImage: IContentImage | null;
    afterText: string;
    descriptionFeatures: IFeaturedItem[] | undefined;
  };
}

const PartDescription: FC<IPartDescriptionProps> = ({
  data: {
    beforeImage, beforeText, afterImage, afterText, descriptionFeatures,
  },
}) => (
  <section className={styles.container}>
    <div className={styles.imagesWrap}>
      <div className={styles.imageWrap}>
        <Image
          className={styles.image}
          src={beforeImage?.src ?? ''}
          alt={beforeImage?.alt ?? ''}
          width={beforeImage?.width ?? 0}
          height={beforeImage?.height ?? 0}
          quality={75}
        />
        <div className={styles.badge}>
          <span>{beforeText}</span>
        </div>
      </div>
      <div className={styles.imageWrap}>
        <Image
          className={styles.image}
          src={afterImage?.src ?? ''}
          alt={afterImage?.alt ?? ''}
          width={afterImage?.width ?? 0}
          height={afterImage?.height ?? 0}
          quality={75}
        />
        <div className={styles.badge}>
          <span>{afterText}</span>
        </div>
      </div>
    </div>
    <div className={styles.featureContainer}>
      <ul className={styles.featureList}>
        {descriptionFeatures
            && descriptionFeatures.map((contentItem: IFeaturedItem) => (
              <li key={contentItem.title} className={styles.featureItem}>
                <PartFeatureCaseItem contentItem={contentItem} />
              </li>
            ))}
      </ul>
    </div>
  </section>
);

export default PartDescription;
